import { NavLink } from 'react-router-dom';
import { IconType } from 'react-icons';
import { FaChartLine, FaFileCsv } from 'react-icons/fa';
import { REPORTING_NAV } from '../constants';
import { cn } from '../../../utils/cn';

const ICONS: Record<string, IconType> = {
  analytics: FaChartLine,
  bordereaux: FaFileCsv,
};

export const ReportingNav: React.FC = () => (
  <nav
    className="mb-6 flex gap-1 overflow-x-auto border-b"
    style={{ borderColor: 'var(--color-border-light)' }}
    aria-label="Reporting sections"
  >
    {REPORTING_NAV.map(item => {
      const Icon = ICONS[item.icon] ?? FaChartLine;
      return (
        <NavLink
          key={item.key}
          to={item.to}
          end={item.end}
          className={({ isActive }) =>
            cn(
              'flex items-center gap-2 whitespace-nowrap border-b-2 px-3.5 py-2.5 text-sm font-semibold transition-colors',
              isActive ? 'border-current' : 'border-transparent hover:opacity-80'
            )
          }
          style={({ isActive }) => ({
            color: isActive ? 'var(--color-primary-600)' : 'var(--color-text-secondary)',
          })}
        >
          <Icon className="h-4 w-4" />
          {item.label}
        </NavLink>
      );
    })}
  </nav>
);
